/* Baby Fair - quick view modal, quick add to cart, wishlist toggle.
   Cart writes are delegated to babyfair-cart.js (window.BFCart) when present,
   so adding from a card or the quick view opens the cart drawer. */
(function () {
  'use strict';

  /* several sections include this file; run it only once per page so every
     click is handled exactly once (a second copy undid wishlist taps) */
  if (window.__bfQuickviewLoaded) return;
  window.__bfQuickviewLoaded = true;

  var modal = null;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function make(html) { var d = document.createElement('div'); d.innerHTML = html; return d.firstElementChild; }

  function ensureModal() {
    if (modal) return modal;
    modal = make('<div class="bf-qv" aria-hidden="true"><div class="bf-qv__scrim" data-qv-close></div><div class="bf-qv__dialog" role="dialog" aria-modal="true" aria-label="Product quick view"><button type="button" class="bf-qv__close" data-qv-close aria-label="Close quick view">&times;</button><div class="bf-qv__inner" data-qv-inner></div></div></div>');
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-qv-close]')) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });
    return modal;
  }

  function openModal(url) {
    var m = ensureModal();
    var inner = m.querySelector('[data-qv-inner]');
    var base = url.split('?')[0];
    inner.innerHTML = '<div class="bf-qv__loading"><span class="bf-qv__spin"></span></div>';
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bf-drawer-open');
    requestAnimationFrame(function () { m.classList.add('is-in'); });

    fetch(base + '?section_id=babyfair-quick-view', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-qv-content]');
        if (!node) throw new Error('shape');
        inner.innerHTML = node.innerHTML;
        wire(inner);
      })
      .catch(function () {
        inner.innerHTML = '<div class="bf-qv__loading"><p style="font-size:13px;color:#7c7c7c;text-align:center">This product could not be loaded here.<br><a href="' + base + '" style="text-decoration:underline">Open the full product page</a></p></div>';
      });
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-in');
    if (!document.body.classList.contains('bf-cart-open')) document.body.classList.remove('bf-drawer-open');
    setTimeout(function () {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      var inner = modal.querySelector('[data-qv-inner]');
      if (inner) inner.innerHTML = '';
    }, 280);
  }

  function wire(root) {
    var store = root.querySelector('[data-qv-variants]');
    var variants = [];
    try { variants = JSON.parse(store.textContent); } catch (e) { }

    var groups = [].slice.call(root.querySelectorAll('[data-qv-optgroup]'));
    var priceEl = root.querySelector('[data-qv-price]');
    var cmpEl = root.querySelector('[data-qv-cmp]');
    var badge = root.querySelector('[data-qv-badge]');
    var img = root.querySelector('[data-qv-img]');
    var atc = root.querySelector('[data-qv-atc]');
    var buy = root.querySelector('[data-qv-buy]');
    var qty = root.querySelector('[data-qv-qty]');
    var current = variants[0] || null;

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-qv-minus]') && qty) qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
      if (e.target.closest('[data-qv-plus]') && qty) qty.value = (parseInt(qty.value, 10) || 1) + 1;
      var w = e.target.closest('[data-qv-wish]');
      if (w) {
        /* save to the same wishlist the product cards and wishlist page use */
        var h = qvHandle();
        if (h && window.BFWishlist && window.BFWishlist.toggle) {
          w.classList.toggle('is-active', window.BFWishlist.toggle(h));
        } else {
          w.classList.toggle('is-active');
        }
      }
    });

    function qvHandle() {
      var full = root.querySelector('.bf-qv__full');
      var href = full ? String(full.getAttribute('href') || '') : '';
      var i = href.indexOf('/products/');
      if (i === -1) return '';
      var h = href.slice(i + 10).split('?')[0].split('#')[0].split('/')[0];
      try { return decodeURIComponent(h); } catch (err) { return h; }
    }
    (function () {
      var w = root.querySelector('[data-qv-wish]');
      var h = qvHandle();
      if (w && h && window.BFWishlist && window.BFWishlist.has) w.classList.toggle('is-active', window.BFWishlist.has(h));
    })();

    function chosen() {
      return groups.map(function (g) {
        var r = g.querySelector('input:checked');
        var lab = g.querySelector('[data-qv-optlabel]');
        if (lab && r) lab.textContent = r.value;
        return r ? r.value : null;
      });
    }
    function find(sel) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < sel.length; j++) { if (variants[i].options[j] !== sel[j]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }
    function paint() {
      var v = find(chosen());
      current = v;
      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
        if (buy) buy.disabled = true;
        return;
      }
      if (priceEl) priceEl.textContent = v.price;
      if (cmpEl) { cmpEl.textContent = v.compare; cmpEl.hidden = !v.has_compare; }
      if (badge) { badge.textContent = '-' + v.pct + '%'; badge.hidden = !v.has_compare; }
      var pic = v.image;
      if (!pic) {
        /* borrow the picture of a sibling variant that shares an option value */
        var sel = chosen();
        for (var k = 0; k < sel.length && !pic; k++) {
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].image && variants[i].options[k] === sel[k]) { pic = variants[i].image; break; }
          }
        }
      }
      if (img && pic) img.src = pic;
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Add To Cart' : 'Sold Out'; }
      if (buy) buy.disabled = !v.available;
    }
    /* a sold out pick moves the other options to the nearest in-stock match */
    function autoPick(gi) {
      var sel = chosen();
      var exact = find(sel);
      if (exact && exact.available) return;
      var best = null, bestScore = -1;
      for (var i = 0; i < variants.length; i++) {
        var vv = variants[i];
        if (!vv.available || vv.options[gi] !== sel[gi]) continue;
        var keep = true;
        for (var j0 = 0; j0 < gi; j0++) { if (vv.options[j0] !== sel[j0]) { keep = false; break; } }
        if (!keep) continue;
        var sc = 0;
        for (var j = gi + 1; j < sel.length; j++) { if (vv.options[j] === sel[j]) sc++; }
        if (sc > bestScore) { best = vv; bestScore = sc; }
      }
      if (!best) return;
      groups.forEach(function (g, j) {
        [].forEach.call(g.querySelectorAll('input'), function (inp) { if (inp.value === best.options[j]) inp.checked = true; });
      });
    }
    groups.forEach(function (g, gi) { g.addEventListener('change', function () { autoPick(gi); paint(); }); });
    if (groups.length) paint();

    if (atc) atc.addEventListener('click', function () {
      if (current) addToCart(current.id, (qty && parseInt(qty.value, 10)) || 1, atc, 'Added to cart', false);
    });
    if (buy) buy.addEventListener('click', function () {
      if (current) addToCart(current.id, (qty && parseInt(qty.value, 10)) || 1, buy, null, true);
    });
  }

  function addToCart(id, quantity, btn, doneText, toCheckout) {
    var old = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    if (!toCheckout && window.BFCart && typeof window.BFCart.add === 'function') {
      return window.BFCart.add(id, quantity, true).then(function () {
        if (btn) { btn.disabled = false; btn.textContent = old; }
        closeModal();
      });
    }

    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity }] }),
      credentials: 'same-origin'
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        if (toCheckout) { window.location.href = ROOT + 'checkout'; return; }
        if (window.BFCart && window.BFCart.refresh) window.BFCart.refresh();
        if (btn) {
          btn.textContent = doneText || 'Added';
          btn.classList.add('is-done');
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = old;
            btn.classList.remove('is-done');
          }, 1500);
        }
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = old; }
        window.location.href = ROOT + 'cart';
      });
  }

  document.addEventListener('click', function (e) {
    var qv = e.target.closest('[data-bf-qv]');
    if (qv) { e.preventDefault(); openModal(qv.getAttribute('data-bf-qv')); return; }
    var add = e.target.closest('[data-bf-add]');
    if (add) { e.preventDefault(); addToCart(add.getAttribute('data-bf-add'), 1, add, 'Added', false); return; }
    var wish = e.target.closest('[data-bf-wish]');
    if (wish) { e.preventDefault(); wish.classList.toggle('is-active'); }
  });
})();
